export default __webpack_public_path__ + "static/realWorldImg1-943871b625d31324706a2a663ce27b4b.png";